module.exports = __webpack_public_path__ + "static/img/products application_redmud3.32789ba5.jpg";